<template>
  <section class='section'>
    <!-- Form Employee -->
    <transition name='fade'>
      <div class="card" v-if="createState">
        <div class="card-content">
          <div class='columns is-desktop'>
            <div class='column is-4'>
              <div class="file is-medium is-boxed has-name">
                <label class="file-label" style='width: 100%;'>
                  <input class="file-input" type="file" @change="uploadData" name="resume">
                  <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label has-text-centered" style='justify-content: center'>
                    <i class="material-icons">cloud_upload</i>
                    <div class='is-size-7'>Clic para subir un archivo xlsx</div>
                  </span>
                </span>
                  <span class="file-name has-text-centered text-dots" style='width: 100%; max-width: 100%'>
                  {{nameFile ? nameFile : '...'}}
                </span>
                </label>
              </div>
              <br>
              <div class="file has-name" v-if="createState" @click="showModalExampleEmpl">
                <label class="file-label" style="width: 100%;">
                <span class="file-cta has-text-centered">
                  <span class="file-icon">
                    <i class="material-icons">description</i>
                  </span>
                </span>
                  <span class="file-name" style="max-width: none; width: 100%;">
                  Plantilla de empleados
                </span>
                </label>
              </div>
            </div>
            <div class='column is-8'>
              <div class="field">
              <span class="subtitle">
                Introduce la siguiente información para crear un empleado manualmente
              </span>
                <div class="field" style='margin-top: 7px;' >
                  <div class="control has-icons-left">
                    <input
                        v-model="employee.email"
                        class="input"
                        type="email"
                        placeholder="Correo"
                        id='email'
                        name='email'
                    />
                    <span class="icon is-small is-left">
            <i class="material-icons">email</i>
          </span>
                  </div>
                </div>
                <div class="field">
                  <div class="control has-icons-left">
                    <input
                        v-model="employee.nombre"
                        class="input"
                        type="text"
                        placeholder="Nombre"
                        id='name'
                        name='name'
                    />
                    <span class="icon is-small is-left">
            <i class="material-icons">face</i>
          </span>
                  </div>
                </div>
                <div class='columns'>
                  <div class="field column">
                    <div class="control has-icons-left">
                      <input
                          v-model="employee.dependencia"
                          class="input"
                          type="text"
                          placeholder="Dependencia"
                          id='dependencies'
                          name='dependencies'
                      />
                      <span class="icon is-small is-left">
                    <i class="material-icons">home_work</i>
                  </span>
                    </div>
                  </div>
                  <div class="field column">
                    <div class="control has-icons-left">
                      <input
                          v-model="employee.cargo"
                          class="input"
                          type="text"
                          placeholder="Cargo"
                          id='position'
                          name='position'
                      />
                      <span class="icon is-small is-left">
                    <i class="material-icons">directions_walk</i>
                  </span>
                    </div>
                  </div>
                </div>
                <div class="buttons">
                  <button class="button is-link" @click="saveEmployee">
                    Guardar
                  </button>
                  <button class="button is-light" @click="showForm">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <br>
    <!-- Progress -->
    <progress
        v-show="advanceUpload > 0"
        class="progress is-info is-small"
        :value="advanceUpload"
        max="100"
    ></progress>

    <!-- Table -->
    <table-ag ref='tableEmployeesLeader' :row-data='employees' :column-defs='columns' :components='components' :component-menu='componentMenu' :actions='true'></table-ag>

    <!-- Others components -->
    <modalexampleempl
        :show="showData"
        @showmodalexampleempl="showModalExampleEmpl"
    ></modalexampleempl>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import modalexampleempl from "@/components/modals/Modalexampleempl.vue";
import {mapState} from "vuex";
import tableAg from '../dashboard/tableAg.vue';
import _f from '@/helpers/functions';

const ButtonAction = {
  template: `
  <div v-if="!tokenUser.ghumana" class='is-flex' :class='isMovil ? "is-justify-center" : "" '>
    <button
        :disabled="createState"
        class="button"
        :class="createState ? 'is-light':'is-dark'"
        @click="openForm"
    >
      <span class="icon">
        <i class="material-icons">add_circle</i>
      </span>
      <span>Crear</span>
    </button>
  </div>
  `,
  data() {
    return {};
  },
  props:{
    params: Object,
    proceso: Object,
    createState: Boolean
  },
  computed: {
    ...mapState(["tokenUser","isMovil"]),
  },
  methods:{
    openForm(){
      this.$emit('showForm')
    },
  }
};
export default {
  data(){
    return {
      columns:[
        {
          field: 'nombre',
          headerName:'Nombre',
          editable: false
        },{
          field: 'email',
          headerName:'Correo',
          editable: false
        },{
          field: 'cargo',
          headerName:'Cargo',
          editable: false,
          resizable: true,
          tooltipValueGetter: params => { return params.value },
          width: 120,
        },{
          field: 'dependencia',
          headerName:'Dependencia',
          editable: false,
          resizable: true,
          tooltipValueGetter: params => { return params.value },
          width: 120,
        },
        {
          field: '_id',
          headerName:'Controles',
          colId: '_actions',
          editable: false,
          cellRenderer: 'buttonsActionEmployee',
          cellRendererParams: {
            editData: this.editData
          },
          hide: this.tokenUser.ghumana,
          sortable: false,
          width: 90,
          pinned: 'right'
        }
      ],
      columnShowDepend: {
        editable: false,
        resizable: false,
        filter: false,
        headerComponent: 'HeaderDependLeader',
        width: 20
      },
      employees:[],
      createState: false,
      showData: false,
      advanceUpload: 0,
      employee: {
        email: "",
        nombre: "",
        cargo: "",
        dependencia: "",
        proceso: "",
        _id: null,
      },
      componentMenu: () => {
        return {
          render: h => h(ButtonAction, {
            props: {
              proceso: this.proceso,
              createState: this.createState
            },
            on:{
              showForm: this.showForm,
              getEmployees: this.getEmployees,
            }
          })
        };
      },
      components: {},
      nameFile: null,
      statusButton: true,
    }
  },
  props: {
    proceso: {
      type: Object,
    },
    tokenUser:{
      type: Object,
    }
  },
  computed: {
    ...mapState(["idtoken"]),
  },
  beforeMount() {
    this.$emit('calculateProcess')
  },
  methods:{
    // Table
    async getEmployees(depend = true) {
      let result;
      try {
        result = await apiServices.get(`/listliderempleados/${this.proceso._id}`);
        if (result.data) {
          this.employees = result.data;
          if (depend) {
            const dependencies = this.employees[0].dependencias ? Object.keys(this.employees[0].dependencias).map(x => {
              return {
                field: 'dependencias',
                headerName: _f.capitalize(x.toLowerCase().split('depend-')[1]),
                valueGetter: (params) => {
                  return params.data[params.colDef.field][x]
                },
                editable: false,
                resizable: true,
                width: 120,
                tooltipValueGetter: params => { return params.value },
                hide: true
              }
            }) : []
            if (dependencies.length) this.columns = this.columns.concat([this.columnShowDepend, ...dependencies])
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Actions
    editData(d) {
      this.employee.email = d.email;
      this.employee.nombre = d.nombre;
      this.employee.cargo = d.cargo;
      this.employee.dependencia = d.dependencia;
      this.employee.proceso = d.proceso;
      this.employee._id = d._id;
      this.createState = true;
      this.scrollTop();
    },
    uploadData(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.avaceupload = 10;
        task.on(
            "state_changed",
            (snapshot) => {
              const porcentaje =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              if (porcentaje > 10) {
                _this.avaceupload = porcentaje;
              }
            },
            (err) => {
              console.log("error subiendo el archivo", err);
            },
            async () => {
              try {
                const url = await task.snapshot.ref.getDownloadURL();
                _this.avaceupload = 0;
                const data = {
                  url: url,
                  proceso: this.proceso._id
                };
                const result = await apiServices.post(`/saveempleadoslote`, data);
                if (typeof result.data === "string"){
                  await this.$store.dispatch("notify", {
                    message: result.data,
                    type: "is-warning",
                    position: "top-right",
                    duration: 3000,
                  });
                  e.target.files = null;
                  return false;
                }else if (result.data) {
                  e.target.files = null;
                  await this.$store.dispatch("notify", {
                    message: `Empleados cargados correctamente`,
                    type: "is-link",
                  });
                  await this.getEmployees(false);
                }
              } catch (err) {
                console.log("ocurrio un error", err);
              }
            }
        );
      }
    },
    async saveEmployee() {
      let result;
      this.employee.proceso = this.proceso._id;
      try {
        if (!this.employee.email) {
          await this.$store.dispatch("notify", {
            message: "Debe indicar el correo del empleado.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        if (!this.employee.nombre) {
          await this.$store.dispatch("notify", {
            message: "Debe indicar el nombre del empleado.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        if (!this.employee.cargo) {
          await this.$store.dispatch("notify", {
            message: "Debe indicar el cargo del empleado.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        if (!this.employee.dependencia) {
          await this.$store.dispatch("notify", {
            message: "Debe indicar la dependencia del empleado.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        if (this.employee._id) {
          result = await apiServices.put(`/editliderempleado`, this.employee);
        } else {
          result = await apiServices.post(
              `/createliderempleado`,
              this.employee
          );
          if (typeof result.data === "string"){
            await this.$store.dispatch("notify", {
              message: result.data,
              type: "is-warning",
              position: "top-right",
              duration: 3000,
            });
            return false;
          }
        }
        if (result.data) {
          await this.$store.dispatch("notify", {
            message: `Perfecto!. Empleado ${
                this.employee._id ? "Editado" : "Creado"
            }.`,
          });
          this.employee = {
            email: "",
            nombre: "",
            cargo: "",
            dependencia: "",
            proceso: "",
            _id: null,
          };
          this.createState = false;
          await this.getEmployees();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Show Components
    showModalExampleEmpl() {
      this.showData = !this.showData;
    },
    showForm(){
      this.createState = !this.createState;
      if (!this.createState) this.employee = {
        email: "",
        nombre: "",
        cargo: "",
        dependencia: "",
        proceso: "",
        _id: null,
      };
    },
    // Helpers
    scrollTop() {
      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: 290,
      });
    }
  },
  created() {
    if (this.idtoken){
      this.getEmployees();
    }
  },
  watch:{
    'idtoken'(nv){
      if (nv){
        this.getEmployees();
      }
    }
  },
  components:{
    tableAg,
    modalexampleempl
  }
}
</script>
<style lang='scss'>
.text-dots{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Empleados.vue